import React from "react";
import Fit from "./Fit";
import "./HeldUp.scss";

const Unfit = () => {
  return <Fit />;
};
export default Unfit;
